export default "/images/cruzdelsur.svg?8aaafba3dfffb0695e08120a3063982d";